import { render, staticRenderFns } from "./ColbFrame.vue?vue&type=template&id=45abcb4a&"
import script from "./ColbFrame.vue?vue&type=script&lang=js&"
export * from "./ColbFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports